'use strict';

var label = require('../util/label');

module.exports = imageReference;

function imageReference(node) {
  return '![' + (this.encode(node.alt, node) || '') + ']' + label(node);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/image-reference.js
// module id = 294
// module chunks = 147254134005266 182246549230831 215303740077764